import React from 'react'

export function ServerOfflineScreen() {
  return (
    <div className={'fixed bg-secondary-xlight my-giga'}>
      <div
        className={
          'w-screen h-screen m-auto text-center text-secondary-medium space-y-mili'
        }
      >
        <a href={window.location.href}>
          <img src='/tecsinapse.png' alt='' width='300' />
        </a>

        <p className={'text-h4 font-bold'}>Atualização em Curso</p>
        <p>
          Estamos realizando uma atualização na aplicação. Por favor, volte
          novamente em instantes.
        </p>
        <p className={'text-sub'}>Equipe TecSinapse.</p>
      </div>
    </div>
  )
}
